import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyC4ROUjeRMbcN5Xv-__-LV-ka9khd1BRiA",
  authDomain: "rahasia-saya.firebaseapp.com",
  databaseURL: "https://rahasia-saya.firebaseio.com",

  clientId: "831293408841-v2ua04dgqp0vglsn51e4804nq7huck5g.apps.googleusercontent.com",

  scopes : ["email", "profile"]
}

firebase.initializeApp(config)

const database = firebase.database()

export default database